import { render, staticRenderFns } from "./WeddingAbc.vue?vue&type=template&id=7d4a2bb0&scoped=true&"
import script from "./WeddingAbc.vue?vue&type=script&lang=js&"
export * from "./WeddingAbc.vue?vue&type=script&lang=js&"
import style0 from "./WeddingAbc.vue?vue&type=style&index=0&id=7d4a2bb0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d4a2bb0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard,VCardText,VCardTitle})
